export default __webpack_public_path__ + "static/media/kidsLogo.1373caa9.png";